export default "__VITE_ASSET__Cnk0$BTE__"